import styled from '@emotion/styled'

export const TipButtonsContainerStyled = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  columnGap: '0.5rem',
})
